(ns app.zap-vault.login.model)

(def step-1 :step-email)
(def step-2 :step-code)

(def root-path [::state])

(def tries-left-key :tries-left)
(def tries-left-full-path (into root-path [tries-left-key]))

(def email-key :email)
(def email-full-path (into root-path [email-key]))

(def step-key :step)
(def step-full-path (into root-path [step-key]))

(def verification-token-key :verification-token)
(def verification-token-full-path (into root-path [verification-token-key]))

(def submitting?-key :submitting?)
(def submitting?-full-path (into root-path [submitting?-key]))

(def error-message-key :error-message)
(def error-message-full-path (into root-path [error-message-key]))

(def processing?-key :processing?)
(def processing?-full-path (into root-path [processing?-key]))

(def email-sent?-key :email-sent?)
(def email-sent?-full-path (into root-path [email-sent?-key]))

(def cool-off-key :cool-off-until-epoch)
(def cool-off-full-path (into root-path [cool-off-key]))

(def can-retry-at-key :can-retry-epoch)
(def can-retry-at-full-path (into root-path [can-retry-at-key]))

(def email-send-error-key :email-send-error-message)
(def email-send-error-full-path (into [email-send-error-key]))

(def code-key :auth-code)
(def code-full-path (into root-path [code-key]))

(def send-code-error-key :code-error)
(def send-code-error-full-path (into root-path [send-code-error-key]))

(def disclaimer-visible?-key :disclaimer-visible?)
(def disclaimer-visible?-full-path (into root-path [disclaimer-visible?-key]))

(def confirmed?-key :confirm?)
(def confirmed?-full-path (into root-path [confirmed?-key]))
